import gql from 'graphql-tag'

export const GET_PRODUCT_LIST = gql`
  query ($page: Int!, $perPage: Int!,$categoryIds: [ID!], $brandIds: [ID!], $search: String) {
    productList(page: $page, perPage: $perPage, categoryIds: $categoryIds, brandIds: $brandIds,search: $search) {
      hasNextPage
      nodes {
        id
        name
        price
        code
        thumbUrl
        images
        subproducts {
          id
          code
          name
          fullName
          available
          price
          pictureUrl
        }
      }
    }
  }
`

export const GET_PRODUCT_LIST_DEFECTIVE = gql`
  query ($subproductIds: [ID!], $stockId: ID!) {
    productList(subproductIds: $subproductIds, stockId: $stockId) {
      nodes {
        id
        name
        thumbUrl
        subproducts {
          id
          name
          price
          available
          pictureUrl
          productStocks {
            id
            lazadaUrl
            shopeeUrl
            stock {
              id
              name
            }
          }
          batches(
            status: ACTIVE
            stockIds: [$stockId]
            perPage: 1000
            page: 1
          ) {
            nodes {
              id
              active
              cost
              available
              subproduct {
                available
              }
              stock {
                id
                name
              }
              supplier {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`
export const GET_PRODUCT_LIST_CREATE_EXCEL = gql`
  query ($stockId: ID!, $page: Int, $perPage: Int) {
    productList(stockId: $stockId, page: $page, perPage: $perPage) {
      pagesCount
      nodes {
        id
        name
        code
        available
        price
        subproducts {
          id
          code
          name
          price
          available
        }
      }
    }
  }
`

export const GET_PRODUCT_LIST_CREATE_EXCEL_VALIDATE = gql`
  query ($subproductIds: [ID!], $perPage: Int) {
    productList(subproductIds: $subproductIds, perPage: $perPage) {
      nodes {
        id
        subproducts {
          id
          name
          available
        }
      }
    }
  }
`

export default {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_DEFECTIVE,
  GET_PRODUCT_LIST_CREATE_EXCEL,
  GET_PRODUCT_LIST_CREATE_EXCEL_VALIDATE
}
